<template>
    <v-data-table
        :headers="headers"
        :items="tipos"
        :items-per-page="5"
        hide-default-footer
        class="elevation-1"
        >
        <!-- select -->
        <template v-slot:[`item.select`]="{ item }">
            <v-select
                :items="jsonYears"
                v-model="item.selectedOption"
                label="Año"
                dense
                outlined
                hide-details
            ></v-select>
        </template>
        <!-- botones -->
        <template v-slot:[`item.actions`]="{ item, index }">
            <v-btn
                class="ma-2"
                style="color: white;"
                :loading="loaders[index] === 'generar'"
                :disabled="loaders[index] === 'generar'"
                color="green"
                @click="generarJson(false, item.selectedOption, item.tipo, index)"
            >
                Generar JSON
                &ensp;<v-icon dark>mdi-code-json</v-icon>
                <template v-slot:loader>
                    <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                    </span>
                </template>
            </v-btn>
            <v-btn
                class="ma-2"
                style="color: white;"
                :loading="loaders[index] === 'limpiar'"
                :disabled="loaders[index] === 'limpiar'"
                color="amber accent-4"
                @click="generarJson(true, item.selectedOption, item.tipo, index)"
            >
                Generar JSON
                &ensp;<v-icon dark>mdi-code-json</v-icon> 
                &ensp;y limpiar cache
                &ensp;<v-icon dark>mdi-cached</v-icon>
                <template v-slot:loader>
                    <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                    </span>
                </template>
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
    const Swal = require('sweetalert2');

    export default {
        data () {
            return {
                loaders: {
                    save: false,
                    remove: false
                },
                save: false,
                remove: false,
                loader: null,
                loading: false,
                availableYears: [],
                jsonYears: [],
                selectedOption: null,
                selectedYear: null,
                selectedYearForJson: null,
                headers: [
                    {
                        text: 'Tipo de Reporte',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                    },
                    { 
                        text: 'Seleccione el Año', 
                        value: 'select', 
                        sortable: false 
                    },
                    { 
                        text: 'Acciones',
                        align: 'start',
                        sortable: false, 
                        value: 'actions' 
                    },
                ],
                tipos: [
                    {name: 'Anual por Magistrados', tipo: 'anual_magistrados'},
                    {name: 'Anual por Salas', tipo: 'anual_salas'},
                ],
            }
        },
        mounted() {
            this.initializeYears();
        },
        methods: {
            // async generarJson(limpiarCache = false, anio, tipo, index) {
            //     this.$set(this.loaders, index, limpiarCache ? 'limpiar' : 'generar');
                
            //     try {
            //         const response = await fetch(`${process.env.VUE_APP_BASE_URL}/reporte/generar`, {
            //             method: "POST",
            //             headers: {
            //                 "Content-Type": "application/json",
            //             },
            //             body: JSON.stringify({
            //                 limpiarCache: limpiarCache,
            //                 anio: anio,
            //                 tipo: tipo,
            //             }),
            //         });

            //             if (response.status === 200) {
            //                     Swal.fire({
            //                     icon: "success",
            //                     title: "Reporte generado",
            //                     text: `El reporte "${tipo}" del año ${anio} se generó correctamente.`,
            //                     confirmButtonColor: "#3085d6"
            //                 });
            //             } else {
            //                 let errorText = await response.text(); // intentamos leer mensaje del servidor
            //                 throw new Error(errorText || `Error ${response.status}`);
            //             }
            //         const data = await response.json();

            //         // console.log("Respuesta del servidor:", data);
            //         // alert(data.message);
            //     } catch (error) {
            //         Swal.fire({
            //             icon: "error",
            //             title: "Error al generar reporte",
            //             // text: "Ocurrió un error inesperado.",
            //             text: error || "Ocurrió un error inesperado.",
            //             confirmButtonColor: "#d33"
            //         });
            //         console.error("Error al generar el JSON:", error);
            //     } finally {
            //         this.$set(this.loaders, index, null);
            //     }
            // },
            async generarJson(limpiarCache = false, anio, tipo, index) {
                
                this.$set(this.loaders, index, limpiarCache ? 'limpiar' : 'generar');
                
                try {
                    const data = await this.$store.dispatch("SAVE_REPORTE", {
                        url: "/reporte/generar",
                        data: { limpiarCache, anio, tipo }
                    });

                    Swal.fire({
                        icon: "success",
                        title: "Reporte generado",
                        text: `El reporte "${anio}_${tipo}" se generó correctamente.`,
                        confirmButtonColor: "#3085d6"
                    });
                } catch (error) {
                    Swal.fire({
                        icon: "error",
                        title: "Error al generar reporte",
                        text: error || "Ocurrió un error inesperado.",
                        confirmButtonColor: "#d33"
                    });
                    console.error("Error al generar el JSON:", error);
                } finally {
                    this.$set(this.loaders, index, null);
                }
            },
            initializeYears() {
                const currentYear = new Date().getFullYear();
                const years = [];

                    for (let year = currentYear; year >= 2010; year--) {
                        years.push(year);
                    }

                this.jsonYears = years;

                // asignar un año inicial a cada tipo de reporte
                this.tipos = this.tipos.map(tipo => ({
                    ...tipo,
                    selectedOption: currentYear   // valor unico por tipo
                }));
            },
        }
    }
</script>

<style scoped>
    .v-subheader {font-size: 1.7rem !important;}
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>